<template>
    <div class="title-container overflow">
        <div class="left float overflow">
            <div class="overflow float can-click return-con" @click="returnPage">
                <span class="el-icon-d-arrow-left float"></span>
                <span class="float" style="line-height:1;margin:0 8px 0 5px;font-weight:700">{{$t('changeAccount.changeAccount20')}}</span>
            </div>
            <span class="float" style="line-height:1;color:#C0C4CC;font-weight:700"> / </span>
        </div>
        <div class="right float overflow" style="margin-left:8px;color:#606266;">
            <span class="float" style="line-height:1">{{pageTitle}}</span>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    props:['pageTitle'],
    methods:{
        returnPage(){
            this.$router.back()
            // this.$router.go(-1);
        },
    },
    created(){

    }
}
</script>
<style lang="less" scoped>
    .return-con span{
        color:#303133;
    }
    .return-con:hover span{
        color: #409EFF;
    }
</style>
